// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoicePdf .InvoicePdf-Totals {
  margin: 0 0 0 auto;
}
.InvoicePdf .InvoicePdf-Totals .Table .TableRow {
  box-shadow: none !important;
}
.InvoicePdf .InvoicePdf-Totals .Table .TableRow.InvoicePdf-Totals-Item-Grand .TableCell.LABEL, .InvoicePdf .InvoicePdf-Totals .Table .TableRow.InvoicePdf-Totals-Item-Grand .TableCell.TOTAL {
  background-color: #e6fdd4;
  border-bottom: 2px solid #ccc;
}
.InvoicePdf .InvoicePdf-Totals .Table .TableRow .TableCell {
  width: 55%;
}
.InvoicePdf .InvoicePdf-Totals .Table .TableRow .TableCell.LABEL {
  width: 25%;
}
.InvoicePdf .InvoicePdf-Totals .Table .TableRow .TableCell.TOTAL {
  width: 20%;
}
.InvoicePdf .InvoicePdf-Totals .Table .TableRow .TableCell .TableCell-Content {
  text-align: right;
  font-weight: 600;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/layouts/Invoice/InvoicePdfTotals/styles.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ;AAEM;EACE,2BAAA;AAAR;AAGY;EAEE,yBAAA;EACA,6BAAA;AAFd;AAMQ;EACE,UAAA;AAJV;AAKU;EACE,UAAA;AAHZ;AAKU;EACE,UAAA;AAHZ;AAKU;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AAHZ","sourcesContent":[".InvoicePdf {\n  .InvoicePdf-Totals {\n    margin: 0 0 0 auto;\n    .Table {\n      .TableRow {\n        box-shadow: none !important;\n        &.InvoicePdf-Totals-Item-Grand {\n          .TableCell {\n            &.LABEL,\n            &.TOTAL {\n              background-color: #e6fdd4;\n              border-bottom: 2px solid #ccc;\n            }\n          }\n        }\n        .TableCell {\n          width: 55%;\n          &.LABEL {\n            width: 25%;\n          }\n          &.TOTAL {\n            width: 20%;\n          }\n          .TableCell-Content {\n            text-align: right;\n            font-weight: 600;\n            text-transform: uppercase;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
